import {redirect} from 'react-router';
import {apiClient} from '@common/http/query-client';
import {BackendResponse} from '@common/http/backend-response/backend-response';

interface CineFrameTodayResponse extends BackendResponse {
  puzzle_id: number;
}

export async function cineFrameIndexLoader() {
  const {puzzle_id: puzzleId} = await apiClient
    .get<CineFrameTodayResponse>('cine-frame/today')
    .then(response => response.data);

  return redirect(`/cine-frame/${puzzleId}`);
}
